import { useEffect, useId, useState } from "react";

const MediumButton = ({
  label = "GET STARTED",
  fill = "#d81591",
  stroke = "2",
  strokeColor = null, 
  // Stroke color for initial state
  width = 320,
  height = 70,
  fontSize = 22,
  fontFamily = "Proxima Nova Bold",
  fontWeight = 700,
  textColor = "#000",
  career = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [textWhite, setTextWhite] = useState(false);
  const clipId = useId();

  useEffect(() => {
    let timeout;
    if (isHovered) {
      // Wait 200ms after hover before changing text color
      timeout = setTimeout(() => {
        setTextWhite(true);
      }, 200);
    } else {
      // Reset immediately when not hovered
      setTextWhite(false);
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [isHovered]);

  // Split label into letters for custom letter spacing like original
  const letters = label.split("");

  // Custom letter spacing map for original design (adjust as needed)
  const letterSpacingMap = {
    S: "-0.01em",
    T: "-0.06em",
    R: "-0.01em",
  };

  const pathD =
    "M284.77,0H35.21C16.97,0,1.96,13.78,0,31.49h43.98l-12.77-12.77c-1.54-1.54-1.54-4.04,0-5.58,1.54-1.54,4.04-1.54,5.58,0l19.41,19.41c.79.79,1.17,1.84,1.15,2.88.02,1.04-.35,2.09-1.15,2.88l-19.41,19.41c-1.54,1.54-4.04,1.54-5.58,0-1.54-1.54-1.54-4.04,0-5.58l12.77-12.77H0c1.96,17.71,16.97,31.49,35.21,31.49h249.56c19.57,0,35.43-15.86,35.43-35.43h0c0-19.57-15.86-35.43-35.43-35.43Z";

  return (
    <div
      style={{
        display: "inline-block",
        cursor: "pointer",
        width: "max-content",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320.2 70.87"
        width={width}
        height={height}
        style={{ overflow: "visible" }}
      >
        <defs>
          <linearGradient
            id="linear-gradient-medium"
            x1="0"
            y1="35.43"
            x2="320.2"
            y2="35.43"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fa5c0d" />
            <stop offset="1" stopColor="#d81591" />
          </linearGradient>

          <clipPath id={clipId}>
            <rect
              x="0"
              y="0"
              width={isHovered ? "321" : "0"}
              height="71"
              style={{
                transition: "width 0.5s ease-in-out",
              }}
            />
          </clipPath>

          <linearGradient
            id="hoverGradient-medium"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="#7e1790" />
            <stop offset="100%" stopColor="#d70a84" />
          </linearGradient>
        </defs>

        <g
          style={{
            transition: "transform 0.3s ease",
            transform: isHovered ? "scale(1.02)" : "scale(1)",
            transformOrigin: "center center",
            transformBox: "fill-box",
          }}
        >
          {/* Base path */}
          <path
            d={pathD}
            fill={fill}
            // stroke={career ? (isHovered ? "url(#linear-gradient-medium)" : strokeColor) : strokeColor}
            stroke={
              career
                ? isHovered
                  ? "url(#linear-gradient-medium)"
                  : strokeColor || "url(#linear-gradient-medium)"
                : strokeColor || "url(#linear-gradient-medium)"
            }
            strokeWidth={career ? (isHovered ? 0 : stroke) : stroke}
            style={{
              transition:
                "stroke 0.3s ease, stroke-width 0.3s ease, fill 0.3s ease",
            }}
          />

          {/* Gradient overlay that reveals from left */}
          <path
            d={pathD}
            fill="url(#hoverGradient-medium)"
            clipPath={`url(#${clipId})`}
          />
        </g>

        {/* Text */}
        <text
          transform="translate(73.24 42.76)"
          style={{
            fill: textWhite ? "#ffffffff" : textColor,
            fontFamily: fontFamily,
            fontSize: `${fontSize}px`,
            fontWeight: fontWeight,
            transition: "fill 0.3s ease",
          }}
        >
          {letters.map((letter, i) => (
            <tspan
              key={i}
              x={i === 0 ? 0 : undefined}
              y={0}
              style={{
                letterSpacing: letterSpacingMap[letter] || undefined,
              }}
            >
              {letter}
            </tspan>
          ))}
        </text>
      </svg>
    </div>
  );
};

export default MediumButton;
